import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getutilizeshift } from "../../services/AnalyticService";
import { Spinner } from "react-bootstrap";
import { useMemo } from "react";
const BusUtilizationChart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [param, setParam] = useState({
    time_period: "week",
  });
  useEffect(() => {
    setLoading(true);
    getutilizeshift(param)
      .then((res) => {
        setData(res.data || []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param]);

  const series = useMemo(() => data.map((item) => item.bus_count), [data]);
  const labels = useMemo(
    () => data.map((item) => item.shift__name?.trim()),
    [data]
  );
  const colors = [
    "hsl(30, 70%, 10.0%)",
    "hsl(30, 70%, 15.0%)",
    "hsl(30, 70%, 20.0%)",
    "hsl(30, 70%, 25.0%)",
  ];

  const options = {
    chart: {
      type: "pie",
    },
    labels,
    colors,
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex];
      },
      style: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
    legend: {
      position: "right",
      fontSize: "11px",
      markers: {
        width: 10,
        height: 10,
        radius: 12,
      },
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          legend: {
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          legend: {
            position: "bottom",
            horizontalAlign: "center",
          },
        },
      },
    ],
    tooltip: {
      y: {
        formatter: (val) => `${val} buses`,
      },
    },
  };

  return (
    <>
      <div className="card">
        <div className=" p-2 d-flex justify-content-between">
          <span className="text-primary" style={{ fontWeight: "500" }}>
            {" "}
            Bus Utilization By Shift
          </span>
          <div className="btn-group">
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "week" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "week" })}
            >
              W
            </button>
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "month" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "month" })}
            >
              M
            </button>
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.time_period === "year" ? "active" : ""
              }`}
              onClick={() => setParam({ time_period: "year" })}
            >
              Y
            </button>
          </div>
        </div>
        <div className="card-body">
          <div>
            {loading ? (
              <div className="text-center my-2">
                <Spinner animation="border" size="sm" />
                <span className="ms-1">Loading...</span>
              </div>
            ) : data?.length == 0 ? (
              <div className="text-center my-2">No Data Found</div>
            ) : (
              <ReactApexChart
                key={series.join(",") + labels.join(",")}
                options={options}
                series={series}
                type="pie"
                height={250}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BusUtilizationChart;
